module.exports = __webpack_public_path__ + "img/empty-echart.df874930.svg";